/** 神策 */
import { getDevices } from '@/utils/getDevice';
import { getCurrentLang } from '@/utils/i18n';
import { getTrackPageType } from '@/constants/sensor';
class Sensors {
  constructor() {
    this.$sensors = null;
    this.IS_DJI_APP = false;
  }

  async init() {
    const sensors = (await import('sa-sdk-javascript')).default;
    const { IS_DJI_APP } = (await import('../constants'));
    sensors.init({
      server_url: process.env.SENSOR_SERVER_URL,
      web_url: process.env.SENSOR_WEB_URL,
      is_track_single_page: true,
      use_client_time: true,
      send_type: 'beacon',
      heatmap: {
        clickmap: 'default',
        scroll_notice_map: 'not_collect',
      },
      app_js_bridge: true,
    });
    this.$sensors = sensors;
    this.IS_DJI_APP = IS_DJI_APP;
  }

  sensorMd(eventName, params = {}) {
    const defaultParams = {
      open_mode: this.IS_DJI_APP ? '站内' : '站外',
      app_ucid: process.env.SENSOR_APP_UCID, // 数据业务归属
      platform_type: 'H5',
      app_channel: getDevices(),
      use_country: 'CN',
      use_language: getCurrentLang,
      h5_type: getTrackPageType(),
    };
    this.$sensors.track(eventName, Object.assign(defaultParams, params));
  }

  handleSensor(sensorName, sensorParam, extraParams = {}) {
    this.sensorMd(
      sensorName,
      {
        page_title_h5: sensorParam.sensorPageTitle,
        ...extraParams,
      },
    );
  }

}

export default new Sensors();
